import { useEffect } from "preact/hooks";
import { Navbar } from "../../components/layout/Navbar";

export function DocsPage() {
  useEffect(() => {
    document.title = "Sage | Docs";
  }, []);

  return (
    <div>
      <Navbar />
      <main class="app-shell">
      <h2>API Documentation</h2>
      <p class="text-secondary">
        Use the Sage API to look up hash reputation. Free tier: 25 lookups/day, no key required.
      </p>

      <section class="doc-section">
        <h3>Hash Lookup</h3>
        <pre class="code-block">{`POST /v1/reputation/lookups
Content-Type: application/json

{
  "hash": "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
}`}</pre>
      </section>

      <section class="doc-section">
        <h3>Supported Hashes</h3>
        <table class="docs-table">
          <tr><th>Algorithm</th><th>Length</th><th>Example</th></tr>
          <tr><td>MD5</td><td>32 hex</td><td><code>d41d8cd9...4e</code></td></tr>
          <tr><td>SHA1</td><td>40 hex</td><td><code>da39a3ee...0e</code></td></tr>
          <tr><td>SHA256</td><td>64 hex</td><td><code>e3b0c442...55</code></td></tr>
        </table>
      </section>

      <section class="doc-section">
        <h3>Response</h3>
        <pre class="code-block">{`{
  "ok": true,
  "data": {
    "report": {
      "hash": { "algorithm": "sha256", "value": "e3b0c4..." },
      "verdict": "clean",
      "confidence": 95,
      "detections": 0,
      "sources": [ ... ]
    }
  }
}`}</pre>
      </section>

      <section class="doc-section">
        <h3>Errors</h3>
        <pre class="code-block">{`{
  "ok": false,
  "error": {
    "code": "VALIDATION_ERROR",
    "message": "Invalid hash format",
    "requestId": "req_abc123"
  }
}`}</pre>
      </section>
    </main>
    </div>
  );
}
